// extracted by mini-css-extract-plugin
module.exports = {"tailfin":"tailfin-hero-banner_component_tailfin__sh4Hh"};